
import { getLabel } from "./Dictionary";

export const dataValidator = (_listParameter) =>
{

  let component = "Validation"

  let displayValue = true; //If you display the value in the error message (set to false for sensitive data)

  //Object to contains the value of the tests if validation fails

  let listResult = [];

  //For Every fields to test
  _listParameter.forEach(param =>
  {

    let currentResult = {
      valid: true,
      field: param.field,
      value: param.value
    }

    const numberPattern = /^-?\d*[.,]?\d+$/;
    const integerPattern = /^(0|[1-9]\d*)$/;

    let listValue = [];

    //For every validation per field
    currentResult.valid = param.listValidation.every(validation =>
    {

      //Split for validation parameters
      let formattedValidation = validation.split(":");

      switch (formattedValidation[0])
      {
        //Check if not null or empty
        case "required":
          if ((!param.value || param.value == "") && param.value !== 0)
          {

            currentResult.reason = getLabel(component, "This field can't be empty.");
            currentResult.code = formattedValidation[0];
            return false;
          }
          return true;
        //Check if valide number
        case "integer":

          if (!integerPattern.test(param.value)) {
            currentResult.reason = getLabel(component, "This field only accepts integers.");
            currentResult.code = formattedValidation[0];
            return false;
          }


          return true;
        case "number":

          if (!numberPattern.test(param.value))
          {
            currentResult.reason = getLabel(component, "This field only accepts numbers.");
            currentResult.code = formattedValidation[0];
            return false;
          }

          return true;
        //Check if is a valid email format
        case "email":
          // Regular expression pattern for email validation
          const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

          if (!emailPattern.test(param.value))
          {
            currentResult.reason = getLabel(component, "Email format is invalid.");
            currentResult.code = formattedValidation[0];
            return false;
          }

          return true;
        //Check if maximum length is respected
        case "max":
          if (param.value && param.value.length > formattedValidation[1])
          {
            
            currentResult.reason = getLabel(component, "This field has exceeded the character limit.") + `[${formattedValidation[1]}]`;
            currentResult.code = formattedValidation[0];
            return false;
          }
          return true;
        //Check if minimum length is respected
        case "min":
          if (!param.value || param.value.length < formattedValidation[1])
          {
            currentResult.reason = getLabel(component, "Insufficient characters in the field.") + `[${formattedValidation[1]}]`;
            currentResult.code = formattedValidation[0];
            return false;
          }
          return true;
        //Check maximum value
        case "maxValue":  
          let maxValue = formattedValidation[1];
          if (numberPattern.test(maxValue)) maxValue = parseInt(maxValue);
          if (numberPattern.test(param.value)) param.value = parseInt(param.value);
          
          if (param.value > maxValue)
          {
            currentResult.reason = getLabel(component, "Value too high.") + `[${maxValue}]`;
            currentResult.code = formattedValidation[0];
            return false;
          }
          return true;
        //Check minimum value
        case "minValue":
          let minValue = formattedValidation[1];
          if (numberPattern.test(minValue)) minValue = parseInt(minValue);
          if (numberPattern.test(param.value)) param.value = parseInt(param.value);

          if ((!param.value && param.value != 0) || param.value < minValue)
          {
            currentResult.reason = getLabel(component, "Value too low.") + `[${minValue}]`;
            currentResult.code = formattedValidation[0];
            return false;
          }
          return true;
        //Check if 2 value match
        case "match":
          if (param.value != formattedValidation[1])
          {
            currentResult.reason = getLabel(component, "Values doesn't match.");
            currentResult.code = formattedValidation[0];
            displayValue = false;
            return false;
          }

          return true;
        case "in":
          listValue = formattedValidation[1].split("|");

          if (!listValue.some(i => i == param.value))
          {
            currentResult.reason = getLabel(component, "Value doesn't exist.");
            currentResult.code = formattedValidation[0];
            displayValue = true;
            return false;
          }

          return true;
        case "notin":
          listValue = formattedValidation[1].split("|");

          if (listValue.some(i => i == param.value))
          {
            currentResult.reason = getLabel(component, "Value already exists.");
            currentResult.code = formattedValidation[0];
            displayValue = true;
            return false;
          }

          return true;
        case "label":

          if (!param.value || !param.value.EN)
          {
            currentResult.reason = getLabel(component, "The label field must contain an English value.");
            currentResult.code = formattedValidation[0];
            return false;
          }

          return true;
        default:
          return true;
      }

    });


    //Manipulate the final value
    if (!currentResult.valid)
    {
      if (!displayValue) //If displayValue = false, replace the value.
        currentResult.value = "<Hidden Value>";
      else if (param.value)//If value is not null, keep it under 100 characters for storage.
      {
        currentResult.value = param.value.toString().substring(0, 100);
      } else //Otherwise set it to ""
      {
        currentResult.value = "";
      }


    }

    listResult.push(currentResult);

  });

  return listResult;

}
